module.exports = __webpack_public_path__ + "img/n6.3e6c7dfa.png";